export const ACTION_REQUEST = 'FETCH_CUSTOMSETTINGS_REQUEST';
export const ACTION_SUCCESS = 'FETCH_CUSTOMSETTINGS_SUCCESS';
export const ACTION_ERROR = 'FETCH_CUSTOMSETTINGS_ERROR';
